import { useQuery } from '@apollo/client';
import { FETCH_SETTING } from 'graphql/queries';

export const useFetchSetting = (variables) => {
  return useQuery(FETCH_SETTING, { variables });
}